import { render } from "./FieldsArrayItem.vue?vue&type=template&id=0d1f2d8e"
import script from "./FieldsArrayItem.vue?vue&type=script&lang=js"
export * from "./FieldsArrayItem.vue?vue&type=script&lang=js"

import "./FieldsArrayItem.vue?vue&type=style&index=0&id=0d1f2d8e&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__